<script setup lang="ts">
import { computed } from 'vue'
import { ElTag } from 'element-plus'
import { getStatusType, statusText } from './StatusUtils'
import { AppointmentStatus, ContainerWatchState } from '~/services/apiClient'
import type { AppointmentWithContainerInfo } from '~/models/appointmentWithContainerInfo'

const props = defineProps<{
  status: AppointmentStatus
  containerInfo?: AppointmentWithContainerInfo
  moveType?: string
}>()

const displayStatus = computed(() => {
  if (
    props.moveType === 'Load Out' &&
    props.containerInfo?.watch?.state === ContainerWatchState.ImportPickedUp
  ) {
    return AppointmentStatus.Completed
  }
  return props.status
})
</script>

<template>
  <ElTag
    :type="getStatusType(displayStatus)"
    round
    disable-transitions
    effect="plain"
    :class="{ scheduled: displayStatus === AppointmentStatus.Scheduled }"
  >
    {{ statusText(displayStatus) }}
  </ElTag>
</template>

<style scoped lang="scss">
$background-color: #fefcff;
$text-color: #d38af2;

.scheduled {
  background-color: $background-color !important;
  color: $text-color;
  border-color: $text-color;
}
</style>
